export const delay = (duration: number, callback: { (): void; (): void; (): void }) => {
    setTimeout(() => {
        callback()
    }, duration)
}
